import { AxiosError } from "axios";
import { call, ForkEffect, put, takeLeading } from "redux-saga/effects";
import { residentsServiceStatusChange } from "../../redux/healthCheck/actions";
import { residentInclude } from "../../redux/residents";
import {
  getResidentsFailure,
  getResidentsPicturesSussess,
  getResidentsRulesAlertsStatusesFailure,
  getResidentsRulesAlertsStatusesSussess,
  getResidentsSussess,
} from "../../redux/residents/action";
import {
  IGetResidentsRequest,
  IGetResidentsStuffRequest,
  RESIDENTS,
} from "../../redux/residents/types";
import { AxiosCustom } from "../../service/Axios";
export function* getResidentsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(RESIDENTS.GET_RESIDENTS_REQUEST, getResidentsSaga);
}

function* getResidentsSaga(action: IGetResidentsRequest) {
  try {
    const response = yield call(() =>
      AxiosCustom.getResidents(action.payload.options)
    );
    yield put(getResidentsSussess(response.data.items));
    const responsePics = yield call(() => AxiosCustom.getResidentsPictures());
    yield put(getResidentsPicturesSussess(responsePics.data.items));
    return response.data.id;
  } catch (error) {
    const e = error as AxiosError;
    if (error?.response?.status === 503)
      yield put(residentsServiceStatusChange(false));
    yield put(getResidentsFailure(e.message));
  }
}

export function* getResidentsStuffWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST,
    getResidentsStuff
  );
}

function* getResidentsStuff(action: IGetResidentsStuffRequest) {
  try {
    const response = yield call(() =>
      AxiosCustom.getResidents({
        include: [
          residentInclude.alerts,
          residentInclude.statuses,
          residentInclude.devices,
        ],
      })
    );
    yield put(getResidentsRulesAlertsStatusesSussess(response.data.items));
  } catch (error) {
    const e = error as AxiosError;
    yield put(getResidentsRulesAlertsStatusesFailure(e.message));
  }
}
